import React from 'react'

const MedicalTechniqueCard = ({data}: any) => {
  return (
    <div className='bg-raspberry-10 rounded-[12px] w-[204px] h-[194px] relative'>
        <h3 className='m-[24px] text-[14px] font-semibold leading-[21px] font-demi'>{data.title.toUpperCase()}</h3>
        {data.img &&
            <img
                src={data.img}
                alt={data.id}
                className='absolute bottom-0 right-0 rounded-bl-[12px]'
            />
        }
    </div>
  )
}

export default MedicalTechniqueCard